export const UPDATE = "conversations/UPDATE";
export const UPDATE_ONE = "conversations/UPDATE_ONE";
export const APPEND = "conversations/APPEND";
export const EMPTY = "conversations/EMPTY";
export const LOADING = "conversations/LOADING";